import { useMemo } from "react";
import { UseQueryArgs } from "urql";

import {
  GetBlueprintVersionById,
  GetBlueprintVersionByIdQueryResult,
  GetBlueprintVersionByIdQueryVariables,
} from "@/graphql/blueprint.graphql";

import { useQueryWithResponseHandler } from "./useQueryWithResponseHandler";

type UseBlueprintDraftProps = Partial<
  UseQueryArgs<GetBlueprintVersionByIdQueryVariables>
> & {
  blueprintVersionId?: string;
};

export const useBlueprintDraft = (props: UseBlueprintDraftProps) => {
  const { blueprintVersionId, variables: variablesFromProps, ...rest } = props;

  const variables = useMemo(
    () => ({
      input: {
        blueprintVersionId,
      },
      ...(variablesFromProps ?? {}),
    }),
    [blueprintVersionId, variablesFromProps],
  );

  const { data, execute, error, state } = useQueryWithResponseHandler<
    GetBlueprintVersionByIdQueryResult,
    GetBlueprintVersionByIdQueryVariables
  >({
    query: GetBlueprintVersionById,
    variables,
    requestPolicy: "cache-first",
    pause: !blueprintVersionId,
    ...rest,
  });

  return {
    data: data?.blueprintVersion,
    execute,
    error,
    state,
  };
};
